import { useEffect, useState } from 'react';

export const useSecretTyping = (secret: string, callback: () => void) => {
  const [, setTyped] = useState('');

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      setTyped((prev) => {
        const newTyped = (prev + e.key).slice(-secret.length);

        if (newTyped.toLowerCase() === secret.toLowerCase()) {
          callback();
          return '';
        }

        return newTyped;
      });
    };

    window.addEventListener('keypress', handleKeyPress);
    return () => window.removeEventListener('keypress', handleKeyPress);
  }, [secret, callback]);
};
